import { render, staticRenderFns } from "./Values.vue?vue&type=template&id=4a9c4a36&scoped=true"
import script from "./Values.vue?vue&type=script&lang=js"
export * from "./Values.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9c4a36",
  null
  
)

export default component.exports